
import React, { forwardRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { UserPlus, FileText, Bell, Check } from "lucide-react";

const HowItWorksSection = forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <section ref={ref} className="py-20">
      <div className="container">
        <div className="mx-auto mb-16 max-w-2xl text-center">
          <h2 className="mb-4 text-3xl font-bold text-navy-800 md:text-4xl">
            How Okkio Works
          </h2>
          <p className="text-lg text-gray-600">
            Our platform makes it easy for citizens to securely report crimes and track the impact of their reports.
          </p>
        </div>

        <div className="mx-auto max-w-4xl">
          <div className="mb-12 flex flex-col items-center md:flex-row md:space-x-8">
            <div className="mb-6 flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-navy-100 text-navy-700 md:mb-0">
              <UserPlus className="h-8 w-8" />
            </div>
            <div>
              <h3 className="mb-2 text-xl font-bold text-navy-800">1. Create an Account</h3>
              <p className="text-gray-600">
                Sign up for a free account with your email address. We only collect the information necessary to verify reports and communicate with you.
              </p>
            </div>
          </div>

          <div className="mb-12 flex flex-col items-center md:flex-row md:space-x-8">
            <div className="mb-6 flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-navy-100 text-navy-700 md:mb-0">
              <FileText className="h-8 w-8" />
            </div>
            <div>
              <h3 className="mb-2 text-xl font-bold text-navy-800">2. Submit a Report</h3>
              <p className="text-gray-600">
                Use our simple report form to provide details about the incident. You can include photos, videos, and location data to help authorities.
              </p>
            </div>
          </div>

          <div className="mb-12 flex flex-col items-center md:flex-row md:space-x-8">
            <div className="mb-6 flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-navy-100 text-navy-700 md:mb-0">
              <Bell className="h-8 w-8" />
            </div>
            <div>
              <h3 className="mb-2 text-xl font-bold text-navy-800">3. Receive Updates</h3>
              <p className="text-gray-600">
                Get notifications about the status of your report. We keep you informed while maintaining your privacy preferences.
              </p>
            </div>
          </div>

          <div className="flex flex-col items-center md:flex-row md:space-x-8">
            <div className="mb-6 flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full bg-navy-100 text-navy-700 md:mb-0">
              <Check className="h-8 w-8" />
            </div>
            <div>
              <h3 className="mb-2 text-xl font-bold text-navy-800">4. Track Community Impact</h3>
              <p className="text-gray-600">
                See how your reports are making a difference with our impact dashboard. View statistics and success stories from your community.
              </p>
            </div>
          </div>

          <div className="mt-12 text-center">
            <Link to="/register">
              <Button className="bg-navy-700 hover:bg-navy-800">Get Started Now</Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
});

HowItWorksSection.displayName = 'HowItWorksSection';

export default HowItWorksSection;
